import classNames from "classnames";
import React, {
    ReactNode,
    useEffect,
    useState,
} from "react";
import Button from "../theme/button/Button";
import Styles from "./ModalWithNavigation.module.scss";
import Confirm from "./Confirm";
import Avatar from "../avatar/Avatar";

export interface ModalWithNavigationCategoryProps<T> {
    value?: T;
    id: string;
    title: string;
    icon?: ReactNode;
    iconUrl?: string;
    postfixIcon?: ReactNode;
}

export interface ModalWithNavigationProps<T> {
    title: string;
    children?: ReactNode;
    navigationFooter?: ReactNode;
    categoryIcon: ReactNode;
    categories: ModalWithNavigationCategoryProps<T>[]
    isDisplayed?: boolean;
    onHide?: () => void;
    selectedCategoryId?: string;
    onSelectedCategory?: (category: T | undefined) => void;
    metricsPathPrefix?: string[];
}

export function ModalWithNavigation<T>({
    children, categories, title, categoryIcon, isDisplayed, selectedCategoryId, metricsPathPrefix,
    onHide, navigationFooter, onSelectedCategory,
}: ModalWithNavigationProps<T>) {
    const [currentCategory, setSelectedCategory] = useState<string>();

    useEffect(() => {
        setSelectedCategory(selectedCategoryId);
    }, [selectedCategoryId]);

    return (

        <Confirm
            shouldShow={isDisplayed ?? false}
            onHide={onHide}
            bodyClassName={Styles.modal}
            className={Styles["modal-dialog"]}
            dialogClassName="full-size-container"
            size="xl"
            shouldShowFooter={false}
            title={title}
        >

            <div className={Styles.container}>
                <div className={Styles.navigation}>
                    <div className={Styles.categories}>
                        <div className={Styles["categories-list"]}>
                            {categories.map(category => {
                                const icon = (category.iconUrl ? (
                                    <Avatar
                                        src={category.iconUrl as string}
                                        className={Styles["category-icon"]}
                                        alt={category.title}
                                        defaultIcon={categoryIcon}
                                        isCircle={false}
                                    />
                                ) : category.icon) ?? categoryIcon;

                                return (
                                    <Button
                                        key={category.id}
                                        type="button"
                                        size="small"
                                        variant="none"
                                        className={classNames(Styles["category-button"], {
                                            [Styles["category-button-selected"]]: currentCategory === category.id,
                                        })}
                                        prefixIcon={icon}
                                        postfixIcon={category.postfixIcon}
                                        onClick={() => {
                                            setSelectedCategory(category.id);
                                            onSelectedCategory?.(category.value);
                                        }}
                                        metricPath={metricsPathPrefix
                                            ? [...metricsPathPrefix, category.id]
                                            : undefined}
                                    >
                                        {category.title}
                                    </Button>
                                );
                            })}
                        </div>
                    </div>
                    {navigationFooter && (
                        <div className={Styles["navigation-footer"]}>
                            {navigationFooter}
                        </div>
                    )}
                </div>
                <div className={Styles.main}>
                    {children}
                </div>
            </div>
        </Confirm>
    );
}

ModalWithNavigation.defaultProps = {
    children: undefined,
    isDisplayed: false,
    onHide: undefined,
    navigationFooter: undefined,
    onSelectedCategory: undefined,
    selectedCategoryId: undefined,
    metricsPathPrefix: undefined,
};
